export default __webpack_public_path__ + "static/media/Icon feather-mail.e8e826ef.svg";